import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { CustomDatePipe } from 'src/app/_pipes/custom-date.pipe';
import { CardComponent } from 'src/app/shared/ui-kit/card/card.component';

import { BusinessLegalProtectionMetadataComponentAbstract } from '../../../metadata-components/business-metadatas/business-legal-protection-metadata/business-legal-protection-metadata.component.abstract';

@Component({
  selector: 'app-business-legal-protection-metadata-v2',
  standalone: true,
  imports: [CommonModule, CardComponent, CustomDatePipe],
  templateUrl: './business-legal-protection-metadata-v2.component.html',
})
export class BusinessLegalProtectionMetadataV2Component extends BusinessLegalProtectionMetadataComponentAbstract {}
